import { Outlet, createRootRoute, useLocation } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/router-devtools';

import { Navbar } from '../components/Navbar';
import { ProtectedRoute } from '../components/ProtectedRoute';

const showDevtools = import.meta.env.MODE !== 'prod';

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  const location = useLocation();

  // If we're on the login page, show a minimal layout
  if (location.pathname === '/login') {
    return (
      <>
        <Outlet />
        {showDevtools && <TanStackRouterDevtools />}
      </>
    );
  }

  return (
    <>
      <div className="min-h-screen bg-gray-50">
        <Navbar />

        <main className="container mx-auto max-w-7xl px-6 flex-grow">
          <ProtectedRoute>
            <Outlet />
          </ProtectedRoute>
        </main>
      </div>
      {showDevtools && <TanStackRouterDevtools />}
    </>
  );
}
